import { blue05, blue20, blue20opacity15 } from '../../../colors/blue';
import { gray20, gray35, gray40opacity20, gray40opacity30, gray40opacity40, gray50, gray80, gray85, } from '../../../colors/gray';
import { red02 } from '../../../colors/red';
export var MuiOutlinedInput = {
    styleOverrides: {
        root: {
            backgroundColor: gray80,
            '&:hover [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: gray20,
            },
            '&.Mui-focused [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: blue05,
            },
            '&.Mui-error [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: red02,
            },
            '&[class*=Mui-error] [class*=MuiOutlinedInput-notchedOutline]': {
                borderColor: red02,
            },
            '&[class*=MuiSelect-secondary]': {
                color: blue20,
                '&:hover': {
                    backgroundColor: gray40opacity30,
                },
                '&[class*=Mui-focused]': {
                    backgroundColor: blue20opacity15,
                },
                '& [class*=MuiSelect-icon]': {
                    color: blue20,
                },
            },
            '& [class*=MuiIconButton-edgeEnd]': {
                '&:hover': {
                    backgroundColor: gray40opacity40,
                },
            },
            '& [class*=MuiInputAdornment-filled]': {
                backgroundColor: gray85,
                borderColor: gray40opacity20,
                color: gray35,
            },
        },
        notchedOutline: {
            borderColor: gray50,
        },
        adornedEnd: {
            '& svg': {
                color: gray20,
            },
        },
        adornedStart: {
            '& svg': {
                color: gray20,
            },
        },
    },
};
